import {Icon} from "@client/components/Icon";
import {Icon as IconLiterals} from "@client/constants";
import {Switch} from "@client/forms";
import * as React from "react";

const BarItem_class =
    "bar-item py-[2.5vw] md:py-3 text-[#181a1b] whitespace-nowrap flex flex-col items-center text-xs font-normal";

type SwitchItem = {
    type: "switch";
    title: string;
    icon: IconLiterals;
    isEnabled: boolean;
};
type ActionItem = {
    type: "action";
    disabled?: boolean;
    highlight?: boolean;
    title: string;
    icon: IconLiterals;
};

type Item = ActionItem | SwitchItem;

interface Props {
    item: Item;
}

export const BarItem = ({item}: Props) => {
    return (
        <div className={BarItem_class}>
            {item.type === "switch" ? (
                <>
                    <Switch name="" onChange={() => {}} value={item.isEnabled} />
                    <Icon icon={item.icon} large="teenager">
                        {item.title}
                    </Icon>
                </>
            ) : (
                <>
                    <Icon
                        highlight={item.highlight}
                        large="teenager"
                        icon={item.icon}
                    />
                    <div>{item.title}</div>
                </>
            )}
        </div>
    );
};
